import React from "react";
import { FormProvider } from "react-hook-form";
import { Stack, Typography } from "@mui/material";

import { useResponsive } from "../../../hooks/useResponsive";
import {
  RFHTextField as RHFTextField,
  RFHToggle as RHFToggle,
} from "../../../components/RFH";
import { CustomButton } from "../../../components/Button/Button";
import { useGoogleAuthLoginForm } from "./hooks/useGoogleAuthLoginForm";

function GoogleAuthLogin({ initialData }) {
  const { methods, formValues, hasChanges, isPending, onSubmit } =
    useGoogleAuthLoginForm(initialData);
  const isMobile = useResponsive("down", "md");

  return (
    <>
      <FormProvider {...methods}>
        <div className="mt-32 form-section  ">
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <div>


              <div className="d-flex mt-32 align-items-center">
              <div className="mr-4">
                <Typography className="setting-heading  ml-0">
                Allow Internal Users to Register Themselves to the Taskboard
                </Typography>
                <div className=" ldap-note ">
                  <Typography className="logo-note">
                    When enabled, team members can register themselves to the Taskboard using their work email address.<br/>
                     When disabled, only admin can register users, only administrators can invite users to join Taskboard.
                  </Typography>
                </div>
              </div>
              <div className="ml-2">
                <RHFToggle name="google_login_enabled" />
              </div>
            </div>
                  </div>

     {/* Show input and note only if toggle is on */}
      {formValues.google_login_enabled && (
        <>
          <Stack
            mt={3}
            direction={isMobile ? "column" : "row"}
            spacing={2.5}
          >
            <RHFTextField
              name="google_workspace_domain"
              label="Google Workspace Domain"
              type="text"
              className="working-hours-text-field"
            />
          </Stack>
          <Typography className="logo-note">
            Note: Enter the domain that is associated with your Organization's Google Workspace account. This is<br />
            typically the part after the "@" in your work email address (e.g., "sofmen.com").
          </Typography>
        </>
      )}
           
            <Stack alignItems="end" className="mt-32">
              <CustomButton
                variant="contained"
                type="submit"
                className="theme-bg-color working-hours-update-button"
                disabled={isPending || !hasChanges()}
              >
                Update
              </CustomButton>
            </Stack>
          </form>
        </div>
      </FormProvider>
    </>
  );
}

export default React.memo(GoogleAuthLogin);
